import {
    post,
    get,
    put,
    del
} from "./http"

const chatbot = {
    // 获取行业信息
    getindusties() {
        return get("industries")
    },
    // 获取全部下发行业信息
    getindustiesAll() {
        return get("industries/all")
    },
    // 上传图片
    uploadImg(params) {
        return post("common/upload", params)
    },
    // 上传表格文件
    uploadExcel(params) {
        return post("client/message/createSpecial", params)
    },
    // 创建机器人
    addrot(params) {
        return post("client/chatbot", params)
    },
    // 修改机器人
    updaterot(params) {
        return put("client/chatbot", params)
    },
    // 获得机器人信息
    getbot(params) {
        return get("client/chatbot", params)
    },
    // 取消审核
    cancelAudit() {
        return put("client/chatbot/audit_status")
    },

    // 获取固定菜单栏信息
    getMenubot(params) {
        return get("client/menu", params)
    },
    // 保存固定菜单栏信息
    saveMenubot(params) {
        return post("client/menu", params)
    },
    // 关联关键字
    menuKeyword(id) {
        return put("client/keyword/" + id + "/menu-name")
    },
    //申请上架
    shelves(params) {
        return put("client/chatbot/shelves", params)
    },
    //申请注销
    cancel(params) {
        return put("client/chatbot/status/cancel")
    },
    //查询服务码
    serviceCode(params) {
        return get("client/codes",params)
    },
    // 修改白名单
    editWhiteList(params) {
        return put("client/chatbot/debug_white_address", params)
    },
    // 上行消息
    uplinkList(params) {
        return get("client/inbound-message", params)
    },
    //批量创建chatbot提交
    batchCreateChatbot(params){
        return post("client/chatbot/batchCreateChatbot",params)
    },

   //以下是新流程改造接口
   // 新流程创建机器人
    createChatbotNew(params) {
        return post("/client/chatbot/v2/create", params)
    },
    // 新流程修改机器人
    updateChatbotNew(params) {
        return post("/client/chatbot/v2/update", params)
    },
    // 新流程获得机器人信息
    getChatbotNew(params) {
        return get("/client/chatbot/v2/getDetail", params)
    },
    batchCreateChatbotV2(params){
        return post("batchCreateChatbotV2",params)
    },

}

export default chatbot